export function removeLastUrlSegment(url?: string): string  {
    // Split the pathname into segments
    const segments = url?.split('/').filter((segment) => segment !== '');
    segments?.pop();
    return segments?.join('/') ?? "/";
}
